import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { AtendimentoDBService } from '../database/atendimento-db.service';

@Injectable({
    providedIn: 'root'
})
export class AtendimentoService extends BaseService {
    override classname: string = 'AtendimentoService';
    public override route: string = 'atendimento';
    public override database = new AtendimentoDBService();
}
